// Puente mínimo a Capacitor sin dependencias: en la web todo es no-op.
const cap = () => window.Capacitor;

export const isNativeApp = () => !!cap()?.isNativePlatform?.();
export const isNativeIOS = () => isNativeApp() && cap().getPlatform?.() === 'ios';

export const APP_SCHEME = 'co.automarketcolombia.app';

// Origen público (dominio web). En la app, window.location.origin es localhost.
export const publicWebOrigin = () =>
  (isNativeApp() ? process.env.REACT_APP_BACKEND_URL : window.location.origin);

export const paymentReturnOrigin = publicWebOrigin;

// Web: redirección actual. App: navegador del sistema y, al volver, resultado en la app.
export async function openWompiCheckout(url, reference) {
  if (!isNativeApp()) { window.location.href = url; return; }
  const { Browser, App } = cap().Plugins;
  let done = false;
  const back = () => {
    if (done) return;
    done = true;
    window.location.assign(`/pago/resultado?ref=${encodeURIComponent(reference)}`);
  };
  await Browser.addListener('browserFinished', back);
  await App.addListener('resume', back);
  await Browser.open({ url });
}

// Google en la app: navegador del sistema (Google bloquea WebViews). La web no usa esto.
export function openGoogleAuthNative() {
  const redirectUrl = `${publicWebOrigin()}/auth/app-callback`;
  cap().Plugins.Browser.open({ url: `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}` });
}

// App: recibe co.automarketcolombia.app://auth/callback#session_id=… y reutiliza /auth/callback.
export function initNativeDeepLinks() {
  if (!isNativeApp()) return;
  const { App, Browser } = cap().Plugins;
  App.addListener('appUrlOpen', ({ url }) => {
    if (!url?.startsWith(`${APP_SCHEME}://auth/callback`)) return;
    const hash = url.includes('#') ? url.slice(url.indexOf('#')) : '';
    Browser.close().catch(() => {});
    if (hash.includes('session_id=')) window.location.assign(`/auth/callback${hash}`);
  });
}
